import { Box } from '@mui/material';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { ReportCardProps as Props } from './types';

export const ReportCard = memo(({ className, title, children }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('ReportCard', className)}
      sx={SX.root}
    >
      <Box sx={SX.header}>{title}</Box>
      {children}
    </Styled.Wrapper>
  );
});

ReportCard.displayName = 'ReportCard';
